import {Browser} from "@capacitor/browser"
import {getAutoLoginUrl} from "../api/user"

export const openForm = async (formId) => {
  await Browser.open({url: await getAutoLoginUrl(`${formId}`), windowName: '_self'})
}